<template>

  <div>
    <nav class="border-b border-gray-300 px-2 md:px-0 py-2 mb-4" v-if="breadcrumb">
      <div class="flex justify-between items-center">
        <div class="">
          <div class="hidden md:flex text-sx">
            <div>Home</div>
            <span class="mx-2">/</span>
            <span>New organization</span>
          </div>
          <div class="text-xl">
            New organization
          </div>
        </div>
      </div>
    </nav>
    <div class="">
      <div class="border p-4 rounded mt-4 overflow-auto">
        <OrganizationSettingsComponent action="Create"/>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationSettingsComponent from "../../components/OrganizationSettingsComponent";

export default {
  name: "CreateOrganization",
  components: {OrganizationSettingsComponent},
  data() {
    return {}
  },
  props: {
    breadcrumb: {type: Boolean, default: true}
  },
  methods: {}
}
</script>

<style scoped>

</style>